import * as React from 'react';

import { ContactPageLocale } from './contactPage.locale';

import styles from './ContactPage.scss';

import Header from '../Header/Header';
import HeaderBox from './HeaderBox/HeaderBox';
import Tabs from '../../containers/Tabs/Tabs';

interface ContactPageProps {
  locale: ContactPageLocale;
}

const ContactPage: React.SFC<ContactPageProps> = ({ locale, children }) => (
  <>
    <Header title={locale.title}>
      <HeaderBox locale={locale.headerBox} />
    </Header>

    <div id="form" />

    <div className="container d-flex justify-content-center mt-5 mb-6">
      <Tabs buttons={locale.tabs} />
    </div>

    <section className={`${styles.contactForm} mb-8`}>{children}</section>
  </>
);

export default ContactPage;



// WEBPACK FOOTER //
// /www/client/src/components/ContactPage/ContactPage.tsx